import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { RecuperarSenhaRoutingModule } from "./recuperar-senha-routing.module";
import { RecuperarSenhaComponent } from "./recuperar-senha.component";
import { AntdModule } from "../../antd.module";
import { ReactiveFormsModule } from "@angular/forms";
import { InputMaskModule } from "@ngneat/input-mask";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
    declarations: [RecuperarSenhaComponent],
    imports: [
        CommonModule,
        RecuperarSenhaRoutingModule,
        AntdModule,
        ReactiveFormsModule,
        InputMaskModule,
        SharedModule,
    ],
})
export class RecuperarSenhaModule {}
